import { render, staticRenderFns } from "./AnSendMail.vue?vue&type=template&id=21636034&"
import script from "./AnSendMail.vue?vue&type=script&lang=js&"
export * from "./AnSendMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports